import { GTCompanyV2Vertical } from 'gql/types.generated'

export const BUSINESS_CLIENT_PRICE_VERTICALS = [GTCompanyV2Vertical.Team, GTCompanyV2Vertical.Rental]
